/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaSelectOneGhostContent/view.blocks to change it.
import Children from 'Simple/Children'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaSelectOneGhostContent({
  children,
  viewPath = "/DesignSystem/TysiaSelectOneGhost/TysiaSelectOneGhostContent",
  parentRef,
  justifyContent = "flex-start",
  backgroundColor = "transparent",
  borderWidth = 1,
  borderColor = "transparent",
  paddingLeft = 0,
  paddingRight = 0,
  paddingBottom = 3,
  paddingTop = 3,
  height = 20,
  maxWidth,
  width = "100%",
  size,
  optionsWidth,
  selectedPlaceholder,
  from,
  focused,
  disabled,
  hovered,
  invalid,
  required,
  valid,
  placeholder,
  value,
  isSelected,
  isMultiChoice,
  isSelectedAll,
  onClick,
  onClickToggleAll,
  onBlur,
  onFocus,
  onChange,
  onSubmit,
  onChangeFilter,
  valueFilter,
  optionValue,
  onKeyUp,
  isShowingOptions,
  innerRef,
  inputRef,
  fromCustom,
  onClickAddFilterAsCustomOption,
  isShowingAddFilterAsCustomOption,
  selected,
  optionsLeft,
  optionsTop,
  optionsRef,
  showSelectAll
  
}) {
  return (<React.Fragment
>
<div
  data-testid="TysiaSelectOneGhostContent.Horizontal"
  data-view-path={viewPath}
 ref={parentRef}
 role="listbox"
 tabIndex={-1}
 style={{'--jc-1-Z22QFNQ': justifyContent,'--bc-2-Z22QFNQ': backgroundColor,'--bw-3-Z22QFNQ': typeof borderWidth === 'number' ? `${borderWidth}px` : borderWidth,'--bc-4-Z22QFNQ': borderColor,'--pl-5-Z22QFNQ': typeof paddingLeft === 'number' ? `${paddingLeft}px` : paddingLeft,'--pr-6-Z22QFNQ': typeof paddingRight === 'number' ? `${paddingRight}px` : paddingRight,'--mw-10-Z22QFNQ': typeof maxWidth === 'number' ? `${maxWidth}px` : maxWidth,'--w-11-Z22QFNQ': typeof width === 'number' ? `${width}px` : width,'--pb-7-Z22QFNQ': size === "small" ? "2px" : size === "tiny" ? "1.5px" : typeof paddingBottom === 'number' ? `${paddingBottom}px` : paddingBottom,'--pt-8-Z22QFNQ': size === "small" ? "2px" : size === "tiny" ? "1.5px" : typeof paddingTop === 'number' ? `${paddingTop}px` : paddingTop,'--h-9-Z22QFNQ': size === "small" ? "16px" : size === "tiny" ? "13px" : typeof height === 'number' ? `${height}px` : height,'--g-12-Z22QFNQ': size === "small" ? "2px" : size === "tiny" ? "1px" : "3px"}}
 className={`views-block ${styles.Horizontal}`}
>
<Children
  viewPath={`${viewPath}/Children`}
 width={optionsWidth}
 selectedPlaceholder={selectedPlaceholder}
 from={from}
 size={size}
 focused={focused}
 disabled={disabled}
 hovered={hovered}
 invalid={invalid}
 required={required}
 valid={valid}
 placeholder={placeholder}
 value={value}
 isSelected={isSelected}
 isMultiChoice={isMultiChoice}
 isSelectedAll={isSelectedAll}
 onClick={onClick}
 onClickToggleAll={onClickToggleAll}
 onBlur={onBlur}
 onFocus={onFocus}
 onChange={onChange}
 onSubmit={onSubmit}
 onChangeFilter={onChangeFilter}
 valueFilter={valueFilter}
 optionValue={optionValue}
 onKeyUp={onKeyUp}
 isShowingOptions={isShowingOptions}
 innerRef={innerRef}
 inputRef={inputRef}
 fromCustom={fromCustom}
 onClickAddFilterAsCustomOption={onClickAddFilterAsCustomOption}
 isShowingAddFilterAsCustomOption={isShowingAddFilterAsCustomOption}
 selected={selected}
 optionsLeft={optionsLeft}
 optionsTop={optionsTop}
 optionsRef={optionsRef}
 optionsWidth={optionsWidth}
 showSelectAll={showSelectAll}
>
{children}
</Children>
</div>
</React.Fragment>)
}